import React from 'react'
import { EntityType, IDailyReportResult, Status } from 'orders/dailySchedule/schemas'
import Badge, { BadgeVariant } from 'uiComponents/badge'
import ClockRegular from '../icons/clockRegular.svg'
import LocationRegular from '../icons/locationRegular.svg'

const getBadgeVariant = (status: Status): BadgeVariant => {
    switch (status) {
        case Status.OVERDUE:
        case Status.EXPIRED:
        case Status.PENDING:
            return 'error'
        case Status.INITIATED:
            return 'info'
        case Status.PAID:
        case Status.CONFIRMED:
            return 'success'
        default:
            return 'neutral'
    }
}

const InfoColumn = ({ dailyReportResult }: { dailyReportResult: IDailyReportResult }) => {
    return (
        <div className="info-column-container">
            <div>
                {dailyReportResult.visitTime && (
                    <div className="event-time-container">
                        <ClockRegular className="clock-icon" />
                        <span className="event-time" title={dailyReportResult.visitTime}>
                            {dailyReportResult.visitTime.slice(0, 5)}
                        </span>
                    </div>
                )}
                {dailyReportResult.location && (
                    <div className="event-location-container" title={dailyReportResult.location.name}>
                        <LocationRegular className="location-icon" />
                        <div className="event-location" title={dailyReportResult.location.name}>
                            {dailyReportResult.location.name}
                        </div>
                    </div>
                )}
            </div>
            <div className="badges-container">
                <Badge
                    variant="info"
                    label={
                        dailyReportResult.entityType === EntityType.RESERVATION
                            ? `Reservation #${dailyReportResult.entityId}`
                            : `Order #${dailyReportResult.entityId}`
                    }
                />
                {dailyReportResult.status && (
                    <Badge variant={getBadgeVariant(dailyReportResult.status)} label={dailyReportResult.status} />
                )}
            </div>
        </div>
    )
}

export default InfoColumn
